module.exports = __webpack_public_path__ + "img/ldap.756897f8.svg";